import { render, staticRenderFns } from "./AddResultat.vue?vue&type=template&id=629eef59&scoped=true"
import script from "./AddResultat.vue?vue&type=script&lang=js"
export * from "./AddResultat.vue?vue&type=script&lang=js"
import style0 from "./AddResultat.vue?vue&type=style&index=0&id=629eef59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629eef59",
  null
  
)

export default component.exports